<template>
</template>

<script>
import printHtml from '@/mixins/printHtml'

export default {
  name: 'PurchasingPurchaseOrdersPrint',
  mixins: [printHtml],
  props: {
    purchaseOrder: {type:Object, required:false},
    purchaseOrders: {type:Array, required:false}
  },
  data() {
    return {
      company: null,
    }
  },
  async created() {
    this.$emit('done');
    if (!this.purchaseOrder && !this.purchaseOrders)
      return;
    const results = await this.$apiCall(`query PurchasingPurchaseOrdersPrint {
                                            company {name,address,city,province,postalCode,email,phone,logoURL}
                                          }`,
                                        {});
    if (results.error)
      return;
    this.company = results.data.company;
    const lines = [`
      <style>
        @page {size:portrait}
        .purchase-order-print {font-family: Roboto, sans-serif; width:100%;border-spacing:0;font-size:12px;text-align:left;border-collapse:collapse;table-layout:fixed}
        .purchase-order-print th {font-weight:normal;vertical-align:top}
        .purchase-order-print .header {border:1px solid #888;text-align:center;padding:4px 8px}
        .purchase-order-print .title {background-color:#b4b4b4}
        .purchase-order-print td {padding:8px 8px}
        .purchase-order-print .right {text-align:right}
        .page-break {page-break-before: always}
      </style>`];

    const logos = this.company.logoURL ? [] : null;
    const purchaseOrders = this.purchaseOrder ? [this.purchaseOrder] : this.purchaseOrders;
    let n = purchaseOrders.length - 1;
    for (const so of purchaseOrders) {
      lines.push(...await this.print(so.id));
      if (n--)
        lines.push(`<div class="page-break"/>`);
      if (logos)
        logos.push({id:so.id, src:this.company.logoURL});
    }
    this.printHtml(this.purchaseOrder?`PO ${this.purchaseOrder.number}`:'Purchase orders', lines.join(''), logos);
  },
  methods: {
    async print(id) {
      const results = await this.$apiCall(`query PurchasingPurchaseOrdersPrint($id:ID!) {
                                              purchaseOrder(id:$id) {
                                                vendorAddress,date,due,shipVia,memo,number,
                                                lines {sku,description,quantity,unitPrice,amount,taxCodeId,precision}
                                                taxLines {
                                                  id,name,amount,onAmount,percent
                                                }
                                              }
                                            }`,
                                          {id});
      if (results.error)
        return;
      const purchaseOrder = results.data.purchaseOrder;
      const lines = [`
        <table class="purchase-order-print">
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <thead>
            <tr>
              <th rowspan="4" colspan="2"><img id="${id}" style="width:72px"/></th>
              <th style="padding-left:20px" rowspan="4" colspan="6">
                <strong>${this.company.name}</strong><br/>
                ${this.company.address || ''}<br/>
                ${this.company.city || ''} ${this.company.province || ''}  ${this.company.postalCode || ''}<br/>
                ${this.company.phone || ''}</br>
                ${this.company.email || ''}
              </th>
              <th style="color:#aaa;font-size:36px;font-weight:700;text-align:right;padding-bottom:20px" colspan="12">PURCHASE ORDER</th>
            </tr>
            <tr>
              <th colspan="4"/>
              <th colspan="4" class="header title">PO #</th>
              <th colspan="4" class="header title">DATE</th>
            </tr>
            <tr>
              <th colspan="4"/>
              <th colspan="4" class="header">${purchaseOrder.number}</th>
              <th colspan="4" class="header">${purchaseOrder.date}</th>
            </tr>
            <tr>
              <th colspan="4"/>
              <th colspan="4" class="header title">SHIP VIA</th>
              <th colspan="4" class="header title">EXPECTED</th>
            </tr>
            <tr>
              <th colspan="8" class="header title">TO</th>
              <th colspan="4"/>
              <th colspan="4" class="header">${purchaseOrder.shipVia}</th>
              <th colspan="4" class="header">${purchaseOrder.due}</th>
            </tr>
            <tr>
              <th colspan="8" style="padding-top:10px;padding-bottom:20px">
                ${purchaseOrder.vendorAddress.replace(/\n/gi,'<br/>')}
              </th>
              <th colspan="12"/>
            </tr>
            <tr>
              <th colspan="3" class="header title">ITEM</th>
              <th colspan="8" class="header title">DESCRIPTION</th>
              <th colspan="3" class="header title">QTY</th>
              <th colspan="3" class="header title">UNIT PRICE</th>
              <th colspan="3" class="header title">AMOUNT</th>
            </tr>
          </thead>
          <tbody>`];
      let subTotal = 0;
      purchaseOrder.lines.forEach(line => {
        subTotal += line.amount;
        lines.push(`<tr>
                      <td colspan="3">${line.sku}</td>
                      <td colspan="8">${line.description}</td>
                      <td colspan="3" class="right">${this.$number(line.quantity, line.precision)}</td>
                      <td colspan="3" class="right">${this.$number(line.unitPrice, 4)}</td>
                      <td colspan="3" class="right">${this.$number(line.amount, 2)}</td>
                    </tr>`);
      });
      lines.push(`<tr>
                    <td colspan="11" rowspan="${2+purchaseOrder.taxLines.length}">${purchaseOrder.memo}</td>
                    <td colspan="3" rowspan="${2+purchaseOrder.taxLines.length}"/>
                    <td colspan="3" class="right"><strong>Subtotal</strong></td>
                    <td colspan="3" class="right header">${this.$currency(subTotal)}</td>
                  </tr>`);
      let total = subTotal;
      purchaseOrder.taxLines.forEach(tax => {
        total += tax.amount;
        lines.push(`<tr>
                      <td colspan="3" class="right"><strong>${tax.name}</strong></td>
                      <td colspan="3" class="right header">${this.$currency(tax.amount)}</td>
                    </tr>`);
      })
      lines.push(`<tr>
                    <td colspan="3" class="right"><strong>Total</strong></td>
                    <td colspan="3" class="right header">${this.$currency(total)}</td>
                  </tr>
                  </tbody>
                </table>`);
      return lines;
    }
  }
}
</script>